import { useCallback, useState } from "react";

import { AjaxResult } from "../../../../enums/ajaxResult";
import { useApi } from "../../../useApi";

export function useDealerLogoLoad(dealerId: number | undefined) {
    const [logo, setLogo] = useState<string>();
    const [loading, setLoading] = useState(false);
    const { dealerApi } = useApi();

    const loadLogo = useCallback(() => {
        if (!dealerId) {
            return;
        }
        setLoading(true);
        setLogo(undefined);
        dealerApi.getLogo(dealerId).then((r) => {
            if (r.result === AjaxResult.Success && r.data) {
                setLogo(URL.createObjectURL(r.data));
            }
            setLoading(false);
        });
    }, [dealerApi, dealerId]);

    return {
        loadLogo,
        logo,
        loading,
    };
}